<template>
	<component :is="component" class="footer-sec-btn" :class="{ plain: plainMode }" v-bind="$attrs" v-on="$listeners">
		<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
			<slot :name="slot" v-bind="scope" />
		</template>
		<template v-for="(index, name) in $slots" v-slot:[name]>
			<slot :name="name" />
		</template>
	</component>
</template>
<script>
import OutlinedButton from '@/components/atoms/buttons/OutlinedButton.vue';

export default {
	name: 'FooterSecondaryButton',
	props: {
		plainMode: { type: Boolean },
	},
	computed: {
		component() {
			return OutlinedButton;
		},
	},
};
</script>
<style lang="scss" scoped>
.footer-sec-btn {
	border-color: #5d5cfc !important;
	color: #5d5cfc !important;
	&.plain {
		height: 25px !important;
		color: #bfc7d6 !important;
		border-color: #bfc7d6 !important;
	}
}
</style>
